import opsional from './opsional'

export default [
  ...opsional,
]
